module.exports = __webpack_public_path__ + "img/betsoft.ee2385a8.svg";